import React from "react";
import cx from "classnames";
import { bool, node } from "prop-types";

const propTypes = {
  isOpen: bool,
  children: node,
};

const ChildMapDialog = (props) => {
  const { isOpen, children } = props;

  return (
    <div
      id="multi-map-child-dialog"
      className={cx("multi-map__child-dialog", {
        open: isOpen,
      })}
      role="dialog"
    >
      {children}
    </div>
  );
};

ChildMapDialog.propTypes = propTypes;
export default ChildMapDialog;
